export default __webpack_public_path__ + "static/media/nextNew.f1566afd.svg";